import React from 'react';
import { Segment, Table, Message } from 'semantic-ui-react';
import Moment from 'moment';
import _ from 'underscore';
import {Link} from 'react-router-dom';

const HradminEmployeeListTable = (props) => {
    return (
        <Segment>
            <Table celled selectable>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Staff Id</Table.HeaderCell>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Status</Table.HeaderCell>
                        <Table.HeaderCell>Start Date</Table.HeaderCell>
                        <Table.HeaderCell>End Date</Table.HeaderCell>
                        <Table.HeaderCell>Last Login</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {
                        _.map(props.employees, (employee) => {
                            const {
                                uuid, staffId, name, status, effectiveStartDate, effectiveEndDate, lastLogin
                            } = employee;
                            return (
                                <Table.Row key={uuid}>
                                    <Table.Cell>
                                        {staffId}
                                    </Table.Cell>
                                    <Table.Cell>
                                        <Link to={`/hradmin/employees/${uuid}`}>
                                            {name.toUpperCase()}
                                        </Link>
                                    </Table.Cell>
                                    <Table.Cell>
                                        {status}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {Moment(effectiveStartDate).format('Do MMMM YYYY')}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {(effectiveEndDate) ? Moment(effectiveEndDate).format('Do MMMM YYYY') : ''}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {Moment(lastLogin).format('DD-MM-YYYY hh:mm:ss')}
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })
                    }
                    {
                        (props.employees.length === 0) ?
                        (
                            <Table.Row>
                                <Table.Cell colSpan={6}>
                                    <Message info>
                                        There are no employees to display.
                                    </Message>
                                </Table.Cell>
                            </Table.Row>
                        )
                        : null
                    }
                </Table.Body>
            </Table>
        </Segment>
    );
}

export default HradminEmployeeListTable;